export function auth(prefix: string) {
  return {
    ROOT: prefix,
    DASHBOARD: `/dashboard${prefix}`,
    LOGIN: `${prefix}/login`,
    PASSWORD_FORGOT: `${prefix}/password-forgot`,
  };
}
